import {initContract} from '@ts-rest/core';
import {DB_SCHEMAS} from '../db/schemaExports';
import {z} from 'zod';
import {paginationQuerySchema, paginatedResponseSchema} from '../utils/pagination';

const c = initContract();

export const tenantsContract = c.router(
  {
    create: {
      method: 'POST',
      path: '/',
      responses: {
        201: DB_SCHEMAS.selectTenant,
        403: z.object({message: z.string()})
      },
      body: DB_SCHEMAS.createTenant
        .pick({
          name: true,
          logo: true
        })
        .extend({
          invitedTenantOwner: z.string()
        }),
      summary: 'Create a tenant'
    },
    get: {
      method: 'GET',
      path: '/:id',
      pathParams: z.object({
        id: z.string()
      }),
      responses: {
        200: DB_SCHEMAS.selectTenant,
        403: z.object({message: z.string()}),
        404: z.object({message: z.string()})
      },
      summary: 'Get a tenant'
    },
    update: {
      method: 'PUT',
      path: '/:id',
      pathParams: z.object({
        id: z.string()
      }),
      body: DB_SCHEMAS.updateTenant,
      responses: {
        200: z.array(DB_SCHEMAS.selectTenant),
        403: z.object({
          message: z.string()
        })
      },
      summary: 'Update a tenant'
    },
    delete: {
      method: 'DELETE',
      path: '/:id',
      pathParams: z.object({
        id: z.string()
      }),
      responses: {
        200: z.array(DB_SCHEMAS.selectTenant),
        403: z.object({message: z.string()}),
        404: z.object({message: z.string()})
      },
      summary: 'Delete a tenant'
    },
    list: {
      method: 'GET',
      path: '/',
      query: paginationQuerySchema.extend({
        sortBy: z.enum(['name', 'createdAt', 'updatedAt']).optional()
      }),
      responses: {
        200: paginatedResponseSchema(DB_SCHEMAS.selectTenant)
      },
      summary: 'List tenants'
    }
  },
  {
    pathPrefix: '/tenants'
  }
);
